module.exports = __webpack_public_path__ + "static/media/resourceQuizzes.b94b5621.svg";